// Skeleton.jsx
import "./skeleton.css";

const Skeleton = ({ dark, count = 1 }) => {
  return (
    
    <div className="skeleton-container">

      <div className="skeleton-header">
        {/* <div className="skeleton avatar shimmer"></div> */}
        <div className="header-text">
          <div className="skeleton line short shimmer"></div>
          <div className="skeleton line medium shimmer"></div>
        </div>
      </div>

      <div className="skeleton image large shimmer"></div>

      <div className="skeleton-content">
        <div className="skeleton line shimmer"></div>
        <div className="skeleton line shimmer"></div>
        <div className="skeleton line shimmer"></div>
        <div className="skeleton line short shimmer"></div>
      </div>

      <div className="image-grid">
        <div className="skeleton image shimmer"></div>
        <div className="skeleton image shimmer"></div>
        <div className="skeleton image shimmer"></div>
      </div>

      <div className="card-section">
        {[1, 2, 3].map((item) => (
          <div className="card" key={item}>
            <div className="skeleton image shimmer"></div>
            <div className="skeleton line shimmer"></div>
            <div className="skeleton line short shimmer"></div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Skeleton;